export default {
  none: 'none',
  replace: 'replace',
  add: 'add',
  remove: 'remove',
};
